import { Fragment, useState } from "react";
import logo2 from "../../Images/logo2.png";
import {
  Button,
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  Transition,
} from "@headlessui/react";
import { Bars3Icon, BellIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { selectLoggedInUser } from "../auth/authSlice";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import NewRegisterModal from "../modal/NewRegisterModal";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function LandingNavbar() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const user = useSelector(selectLoggedInUser);

  return (
    <>
      <Disclosure
        as="nav"
        style={{
          background: "linear-gradient(0deg, #589FF2 -43.37%, #004BA3 100%)",
        }}
      >
        {({ open }) => (
          <>
            <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
              <div className="relative flex h-20 items-center justify-between">
                <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                  {/* Mobile menu button*/}
                  <DisclosureButton className="relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                    <span className="absolute -inset-0.5" />
                    <span className="sr-only">Open main menu</span>
                    {open ? (
                      <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                    ) : (
                      <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                    )}
                  </DisclosureButton>
                </div>
                <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
                  <div className="flex flex-shrink-0 items-center">
                    <img
                      className="h-12 w-auto"
                      src={logo2}
                      alt="Your Company"
                    />
                    <div className="ml-4">
                      <h1 className="hidden md:block text-gray-50 text-lg">
                        Stamp & Registration Department
                      </h1>
                      <h3 className="hidden md:block text-gray-50 text-sm text">
                        Government of Uttarakhand
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
                  {/* Display "Hello, name" instead of notification icon */}
                  <div className="hidden sm:block text-gray-50 mr-3">
                    <Link
                      to="/"
                      className="text-white mr-3 hover:text-gray-300"
                    >
                      Home
                    </Link>
                    <Link
                      to="/About"
                      className="text-white mr-3 hover:text-gray-300"
                    >
                      About
                    </Link>
                    <Link
                      to="/Contact"
                      className="text-white mr-3 hover:text-gray-300"
                    >
                      Contact
                    </Link>
                    <Link
                      to="/Help"
                      className="text-white mr-3 hover:text-gray-300"
                    >
                      Help
                    </Link>
                  </div>
                  <div className="hidden sm:block text-gray-50 mr-3 items-center">
                    <Button
                      onClick={() => setIsModalOpen(true)}
                      className="bg-amber-500 hover:bg-white hover:text-amber-500  text-white py-2 px-5 rounded-full text-md items-center"
                    >
                      Register Now!
                    </Button>
                  </div>
                </div>
              </div>
            </div>

            <Disclosure.Panel className="sm:hidden">
              <div className="px-2 pt-2 pb-3 space-y-1">
                <Link
                  to="/About"
                  className="block text-gray-50 px-3 py-2 rounded-md text-base font-medium hover:bg-gray-700 hover:text-white"
                >
                  About
                </Link>
                <Link
                  to="/Contact"
                  className="block text-gray-50 px-3 py-2 rounded-md text-base font-medium hover:bg-gray-700 hover:text-white"
                >
                  Contact
                </Link>
                <Link
                  to="/Help"
                  className="block w-20 text-gray-50 px-3 py-2 rounded-md text-base font-medium hover:bg-gray-700 hover:text-white"
                >
                  Help
                </Link>
                <Button
                  onClick={() => setIsModalOpen(true)}
                  className="block max-w-44 bg-amber-500 hover:bg-blue-600 text-white py-2 px-4 rounded-full text-base md:text-lg mt-4 mx-auto text-center ml-1"
                >
                  Register Now!
                </Button>
              </div>
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
      {isModalOpen && (
        <NewRegisterModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </>
  );
}
